export const GTM_ID = process.env.NEXT_PUBLIC_GTM_ID

// GTM replays whatever is already on the queue when gtm.js loads, so seeding the
// array keeps events fired before the script arrives instead of dropping them.
const push = (payload: Record<string, unknown>) => {
  globalThis.dataLayer = globalThis.dataLayer || []
  globalThis.dataLayer.push(payload)
}

export const pageView = (url: string) => {
  push({ event: "pageview", page: { path: url } })

  if (process.env.NODE_ENV !== "production") {
    console.log({ url })
  }
}

export const event = ({
  category,
  name,
  action,
  customFields,
}: {
  category: string
  name: string
  action: string
  customFields: Record<string, object>
}) => {
  push({
    category,
    name,
    action,
    details: customFields,
  })

  if (process.env.NODE_ENV !== "production") {
    console.log({ category, name, action, details: customFields })
  }
}
